import { useEffect, useState } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import printerimg from "../../../../assets/print.png";
import {
  usePostUpdateItemAttributeMutation,useGetItemDetailsDataMutation
} from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import FileAttachmentManager  from "../../../../Components/FileAttachmentManager";
import Attachment from "../../../../utils/Attachment";
import { usePageState } from "../../../../Hook/usePageState";
import { isStateChanged } from "../../../../utils/stateComparator";
const EditForm = () => {
    const navigate = useNavigate();
     const location = useLocation();
          const IdData = location.state?.ItemId;
          const [podata, setpodata] = useState('')
    
  // const [tab, settab] = useState(1);
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

  // api varibale
  const [UpdateItemAttribute] = usePostUpdateItemAttributeMutation();

  // tab1
  // const [Numeric_Values, setNumeric_Values] = useState(false);
  // const [AttributeName, setAttributeName] =useState("");
  // const [FromRange, setFromRange] =useState("");
  // const [ToRange, setToRange] =useState("");
  // const [Increment, setIncrement] =useState("");
// const [selected_default_item_attribulte_data, setselected_default_item_attribulte_data] = useState([]);
  // console.log('tbl:',selected_default_item_attribulte_data)
  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
    Numeric_Values: false,
    AttributeName: false,
  });



  const pageStateDefault = {
    tab: 1,
    AttributeName: '',
    Numeric_Values: false,
    FromRange: '',
    ToRange: '',
    Increment: '',
    selected_default_item_attribulte_data: [{ attribute_value: '', abbr: '' }],

  };

  const [pageState, setPageState] = usePageState(`Edit Item Attribute - ${IdData}`, pageStateDefault);


  const { tab, AttributeName, Numeric_Values, FromRange, ToRange, Increment,selected_default_item_attribulte_data } = pageState;

const [AttachmentsList, setAttachmentsList] = useState([]); // ✅ Make sure it's an array
 const [itemDetails, { data, isLoadin }] = useGetItemDetailsDataMutation();

    useEffect(() => {
       if (!isStateChanged(pageState, pageStateDefault)) {
        if (IdData) {
            itemDetails({ doctype: 'Item Attribute', name: IdData })
                .unwrap()
                .then((response) => {
                    const item = response.docs?.[0]; // ✅ safely access first item
  const docinfo = response.docinfo;

  if (!item) return;
                    setpodata(response)
                    console.log(item, "Api response");

                    setPageState({
              ...pageState,
              Numeric_Values: item.numeric_values,
              AttributeName: item.attribute_name,
              FromRange: item.from_range,
              ToRange: item.to_range,
              Increment: item.increment,
              selected_default_item_attribulte_data:item.item_attribute_values
              
            });
                   setAttachmentsList(docinfo.attachments); // ✅ Correct place
                })
                .catch((err) => {
                    console.error('API Error:', err);
                });
        } else {
            console.warn('No Id Data found in location state');
        }
      }
    }, [IdData, itemDetails]);

  const handleSubmit = async () => {
//  console.log('tbl:',selected_default_item_attribulte_data)
setFieldErrors({
    Numeric_Values: false,
    AttributeName: false,
    });

    let hasError = false;
    const newErrors = {
      AttributeName: !AttributeName,
    };
    const FirsthasInvalidItem = "";
    if (FirsthasInvalidItem) {
      newErrors.items = true;
    }
    setFieldErrors(newErrors);
    hasError = Object.values(newErrors).some(error => error);

 
  if (!AttributeName) {
    setptype("Error");
    setError("Please fill Attribute Name.");
    setShowError(true);
    return;
  }



  const payload = {
attribute_name: IdData,
  // attribute_name: AttributeName,               // Required
  numeric_values: Numeric_Values,                    // 0 = False, 1 = True
  from_range: FromRange,                      // Required if numeric_values=1
  to_range: ToRange,                        // Required if numeric_values=1
  increment: Increment,                       // Required if numeric_values=1
  item_attribute_values: selected_default_item_attribulte_data ? selected_default_item_attribulte_data : [],

};

console.log('update Item Attribute payload:',payload)
  try {
    const response = await UpdateItemAttribute(payload); // RTK mutation or fetch

     function stripHTML(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
}

if (response.error) {
  let errorMessage = "Updation failed";

  if (response.error.data && response.error.data._server_messages) {
    try {
      const serverMessages = JSON.parse(response.error.data._server_messages);
      if (Array.isArray(serverMessages) && serverMessages.length > 0) {
        const parsedMessage = JSON.parse(serverMessages[0]);
        errorMessage = parsedMessage.message || errorMessage;
      }
    } catch (e) {
      console.warn("Failed to parse _server_messages", e);
    }
  } else {
    errorMessage =
      response.error.data?.message ||
      response.error.data?.exception ||
      errorMessage;
  }

  // ✅ Strip any HTML tags like <strong> from the final error message
  errorMessage = stripHTML(errorMessage);

  setptype("Error");
  setError(errorMessage);
  setShowError(true);
  return;
}

    setpo_response(response.data);
    setError("Item Attribute updated successfully!");
    setptype("Success");
    setShowError(true);
    // Navigate after a short delay (e.g., 2 seconds)
    setTimeout(() => {
      navigate("/master/item-attribute/item-attribute-list"); // 🔁 Replace with your actual route
    }, 2000);
  } catch (err) {
    setError(err?.data?.message || "Unexpected error occurred.");
    setptype("Error");
    setShowError(true);
  }
};
  return (
    <FormLayoutTwo
      title="Edit Item Attribute"
      breadcrumbs={[
        { label: "Item Attribute"},
        { label: "Item Attribute List", url: "/master/item-attribute/item-attribute-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          <Button
            onClick={() => {}}
            to="/"
            state={po_response?.result}
            style={{ backgroundColor: "#fff", height: "28px" }}
            className="custom-btn-00989blue"
            display={finalstep ? "flex" : "none"}
          >
            + Create
          </Button>

          <Button
            className="custom-btn-bluecolor d-flex"
            iconName="BiCloudUpload"
            style={{ gap: "2px" }}
            iconSize={14}
          >
            Upload
          </Button>

          <Button
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrCopy"
            iconSize={12}
          >
            Duplicate
          </Button>

          <Button
            className="custom-btn-00989"
            onClick={handleSubmit}
            iconName="LuFilePlus2"
            style={{ gap: "2px", height: "28px" }}
            iconSize={12}
            display={finalstep ? "none" : "flex"}
          >
            {po_response.result ? "Submit" : "Save"}
          </Button>

          <Button
            to="/item-attribute/create-item-attribute"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                   setPageState({ ...pageState, tab: 1 })
                  }}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

         <Attachment doctype="Item Attribute"  docname={IdData}  />    

          </div>
        </div>

            <div className=" " style={{ background: '' }}>
          <div className="row">
            <div className="col-12">
              <div >
                <Tab1
                    // setselected_default_item_attribulte_data={setselected_default_item_attribulte_data}
                    // selected_default_item_attribulte_data={selected_default_item_attribulte_data}
                     pageState={pageState}
								     changeState={setPageState}

                    selected_default_item_attribulte_data={{
                      value: pageState.selected_default_item_attribulte_data || [],
                      setValue: (val) =>
                        setPageState({
                          ...pageState,
                          selected_default_item_attribulte_data: val,
                        }),
                    }}
                     Numeric_Values={{
                      value: pageState.Numeric_Values,
                      setValue: (val) => setPageState({ ...pageState, Numeric_Values: val }),
                      error: fieldErrors.Numeric_Values,
                    }}
                    AttributeName={{
                      value: pageState.AttributeName,
                      setValue: (val) => setPageState({ ...pageState, AttributeName: val }),
                      error: fieldErrors.AttributeName,
                    }}
                    FromRange={{
                      value: pageState.FromRange,
                      setValue: (val) => setPageState({ ...pageState, FromRange: val }),
                      error: fieldErrors.FromRange,
                    }}
                    ToRange={{
                      value: pageState.ToRange,
                      setValue: (val) => setPageState({ ...pageState, ToRange: val }),
                      error: fieldErrors.ToRange,
                    }}
                    Increment={{
                      value: pageState.Increment,
                      setValue: (val) => setPageState({ ...pageState, Increment: val }),
                      error: fieldErrors.Increment,
                    }}
                    
                  />
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayoutTwo>
  );
};

export default EditForm;
